/**
 * ObjectJsonPanel React component
 * 
 * @author    Jens Gruschel
 * @copyright © 2020 contexagon GmbH
 */


// React
import React from 'react';
import PropTypes from 'prop-types';

// Material-UI
import {withStyles} from "@material-ui/core";

// application
import JsonEditor from '../base/JsonEditor';


/**
 * ObjectJsonPanel shows an object as JSON
 *
 * @author Jens Gruschel
 */
export class ObjectJsonPanel extends React.Component {

    handleChange(value) {
        this.props.onChange(value || {});
    };

    render() {

        const { classes } = this.props;

        return <div className={classes.root}>
            <JsonEditor
                label="Code"
                helperText="Achtung, unüberlegte Änderungen können das Objekt unbrauchbar machen !!!"
                value={this.props.object}
                readOnly={this.props.readOnly}
                onChange={value => this.handleChange(value)}
            />
        </div>;
    }
}

const styles = theme => ({
    root: {
        width: "100%",
        marginTop: 20,
        marginBottom: 20
    }
});

ObjectJsonPanel.propTypes = {
    object: PropTypes.object.isRequired,
    onChange: PropTypes.func.isRequired,
    readOnly: PropTypes.bool
};

export default withStyles(styles)(ObjectJsonPanel);